module.exports = __webpack_public_path__ + "img/carC8.035b0ab0.png";